import router from '@/router'
import { ElMessage} from 'element-plus'
export const isExternal=(path:string) =>{
    return /^(https?:|mailto:|tel:)/.test(path)
  }
/**
 * 跳转到一个 URL
 * @param url 跳转到的地址
 */
export const gotoURL = (url: string) => {
    if(isExternal(url)){
        window.open(url)
      }else{
        if(url && url.length>0){
          router.push({
            path: url
          })
        }else{
          router.push('/')
        }
      }
}
/**
 * 获取当前路由的 query 参数
 * @returns 当前路由的 query
 */
export const getQuery = () => {
  return router.currentRoute.value.query
}
/**
 * 获取当前路由的 params 参数
 * @returns 当前路由的 params
 */
export const getRouteParam = () => {
  return router.currentRoute.value.params
}
/**
 * 把布尔值转换为数字：0=false，非0=true
 * @param val boolean
 * @returns number
 */
export const boolToInt = (val: boolean) => {
  return val ? 1 : 0
}
/**
 * 把数据转换成boolean
 * @param val number
 * @returns boolean
 */
export const intToBool = (val: number) => {
  return val>0
}

export const StringToInt=(val:string):number=>{
  if(!val){
    return 0
  }
  return parseInt(val)
}
export const getDate = ():string=>{
  const date = new Date()
  return dateToYYYYMMDD(date)
}
export const dateToYYYYMMDD = (date:any):string =>{
  if (!date) {
    return ''
  }
  const year = date.getFullYear()
  let month = date.getMonth()// 月份是从0开始的
  const day = date.getDate()

  if (!year || month < 0 || !day) {
    return ''
  }
  month = month + 1// 月份是从0开始的

  return year.toString() + '-' + month.toString() + '-' + day.toString()
}
/**
 * 转换为json
 * @param data 
 * @returns 
 */
export const JsonToString=(data:any):string=>{
  if(!data){
    return ''
  }
  return JSON.stringify(data)
}
export const StringToJson=(data:string):any=>{
  if(!data){
    return {}
  }
  return JSON.parse(data)
}
export const showError=(msg:string)=>{
  ElMessage.warning({
    message: msg,
    type: 'error'
  })
}
export const showMsg=(msg:string)=>{
  ElMessage.success({
    message: msg,
    type: 'success'
  })
}
// function formatDate(date, formatString = 'yyyy-MM-dd HH:mm:ss') {
//   const options = {
//     yyyy: ''+date.getFullYear(),
//     MM: ('0' + (date.getMonth() + 1)).slice(-2),
//     dd: ('0' + date.getDate()).slice(-2),
//     HH: ''+date.getHours(),
//     mm: ('0' + date.getMinutes()).slice(-2),
//     ss: ('0' + date.getSeconds()).slice(-2),
//     // 可以添加更多格式选项，如星期、季度等
//   }

//   return formatString.replace(/(yyyy|MM|dd|HH|mm|ss)/g, (match:string) => options[match]);
// }

export default {
  gotoURL,
  getQuery,
  getRouteParam,
  boolToInt,
  intToBool,
  JsonToString,
  StringToJson,
  StringToInt,
  getDate,
  dateToYYYYMMDD,
  showError,
  showMsg
}